module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('float-btn', {
    staticClass: "btn-success clickable",
    on: {
      "click": _vm.openCreateEventModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.createModal.title')))])]), _c('float-btn', {
    staticClass: "btn-info"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  }), _c('a', {
    staticClass: "btn btn-danger clickable",
    on: {
      "click": _vm.openConfigurationModal
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('globals.configure')))])]), (_vm.isListView) ? _c('a', {
    staticClass: "btn btn-primary clickable",
    on: {
      "click": _vm.asCalendar
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.calendarView')))])]) : _vm._e(), (!_vm.isListView) ? _c('a', {
    staticClass: "btn btn-warning clickable",
    on: {
      "click": _vm.asMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.monthView.letter'))), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.monthView.label')))])]) : _vm._e(), (!_vm.isListView) ? _c('a', {
    staticClass: "btn btn-warning clickable",
    on: {
      "click": _vm.asWeek
    }
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.weekView.letter'))), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.weekView.label')))])]) : _vm._e(), (!_vm.isListView) ? _c('a', {
    staticClass: "btn btn-warning clickable",
    on: {
      "click": _vm.asDay
    }
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.dayView.letter'))), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.dayView.label')))])]) : _vm._e(), (!_vm.isListView) ? _c('a', {
    staticClass: "btn btn-primary clickable",
    on: {
      "click": _vm.asList
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('events.fixedBtn.listView')))])]) : _vm._e()]), (!_vm.isListView) ? _c('events-calendar', {
    attrs: {
      "view": _vm.view,
      "eventsBus": _vm.eventsBus
    }
  }) : _vm._e(), (_vm.isListView) ? _c('events-list', {
    attrs: {
      "injected": _vm.injected,
      "eventsBus": _vm.eventsBus
    }
  }) : _vm._e(), _c('events-configuration-modal', {
    attrs: {
      "eventsBus": _vm.eventsBus
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a638d37c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events/Events.vue
// module id = 895
// module chunks = 13